export   const cleanCustomHTML = (html) => {
  return html?.replace(/<style[\s\S]*?<\/style>/gi, "");
};
